module.exports = __webpack_public_path__ + "static/media/assign-user.97747735.svg";